export const BUTTON_LABEL = 'Tap me';
export const ALERT_MSG = 'Hello World';
export const WELCOME_MSG = 'Welcome to My Website!';
